/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OperatorCreate } from '../models/OperatorCreate';
import type { OperatorDetails } from '../models/OperatorDetails';
import type { OperatorUpdate } from '../models/OperatorUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class OperatorsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async operatorsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/operators/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/operators/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVUpdateOperator(
        operatorId: string,
        requestBody?: OperatorUpdate,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/operators/${operatorId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVGetById(
        operatorId: string,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/operators/${operatorId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns OperatorDetails Created
     * @throws ApiError
     */
    public static async operatorsVCreate(
        requestBody?: OperatorCreate,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/operators`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @returns boolean OK
     * @throws ApiError
     */
    public static async operatorsVIsOnRocketpack(
        operatorId: string,
    ): Promise<boolean> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/operators/${operatorId}/is-on-rocketpack`,
        });
        return result.body;
    }

}